import { rgbaToCss } from '../utils/color.js';
import { percentToCss } from '../utils/css.js';

const DEFAULT_CENTER = { x: 0.5, y: 0.5 };
function fillStyle(fill) {
    switch (fill.type) {
        case 'color':
            return { background: colorToCss(fill.color) };
        case 'multicolor':
            return { background: multicolorBackground(fill) };
        case 'linear':
            return {
                background: `linear-gradient(${fill.angle ?? 90}deg${interpolationToCss(fill.interpolation)}, ${stopsToCss(fill.stops)})`,
            };
        case 'radial':
            return {
                background: `radial-gradient(circle closest-side at ${centerToCss(fill.center)}${interpolationToCss(fill.interpolation)}, ${stopsToCss(fill.stops)})`,
            };
        case 'angular':
            return {
                background: `conic-gradient(from ${fill.angle ?? 0}deg at ${centerToCss(fill.center)}${interpolationToCss(fill.interpolation)}, ${stopsToCss(fill.stops)})`,
            };
        case 'diamond':
            return {
                background: diamondBackground(fill),
                transform: fill.angle ? `rotate(${fill.angle}deg) scale(1.5)` : undefined,
                transformOrigin: centerToCss(fill.center),
            };
        case 'image':
        case 'custom':
            return {};
    }
}
function colorToCss({ r, g, b, a }) {
    return rgbaToCss(r, g, b, a, 'srgb');
}
function multicolorBackground({ colors, angle = 90 }) {
    const segment = 1 / colors.length;
    const stops = colors.flatMap((color, index) => {
        const start = percentToCss(index * segment);
        const end = percentToCss((index + 1) * segment);
        return [`${colorToCss(color)} ${start}`, `${colorToCss(color)} ${end}`];
    });
    return `linear-gradient(${angle}deg, ${stops.join(', ')})`;
}
function interpolationToCss(interpolation) {
    if (!interpolation)
        return '';
    return ` in ${interpolation.colorSpace}${interpolation.hue ? ` ${interpolation.hue} hue` : ''}`;
}
function stopsToCss(stops) {
    return stops.map(stopToCss).join(', ');
}
function stopToCss({ color, position }) {
    return `${colorToCss(color)} ${percentToCss(position)}`;
}
function centerToCss(center = DEFAULT_CENTER) {
    return `${percentToCss(center.x)} ${percentToCss(center.y)}`;
}
function diamondBackground(fill) {
    const center = fill.center ?? DEFAULT_CENTER;
    const x = percentToCss(center.x);
    const y = percentToCss(center.y);
    const right = percentToCss(1 - center.x);
    const bottom = percentToCss(1 - center.y);
    const stops = stopsToCss(fill.stops);
    const interpolation = interpolationToCss(fill.interpolation);
    // Each quadrant is anchored to the corner it owns. A percentage `background-position` resolves
    // against the container minus the layer, so positioning the inner edges by percent would pull
    // every quadrant toward the center and leave the right and bottom edges unpainted. The sizes
    // already encode where the center sits, so the corner keywords are enough to tile the paint.
    return [
        `linear-gradient(to bottom right${interpolation}, ${stops}) left top / ${x} ${y} no-repeat`,
        `linear-gradient(to bottom left${interpolation}, ${stops}) right top / ${right} ${y} no-repeat`,
        `linear-gradient(to top left${interpolation}, ${stops}) right bottom / ${right} ${bottom} no-repeat`,
        `linear-gradient(to top right${interpolation}, ${stops}) left bottom / ${x} ${bottom} no-repeat`,
    ].join(', ');
}

export { fillStyle };
//# sourceMappingURL=swatch.utils.js.map
